import { customizedFetch } from "./_customizedFetch";
import { appConstants } from "../utils";

export const userInfo = async () => {
  const accessToken = localStorage.getItem(appConstants.IQ_HUB_TOKEN_NAME);

  const response = await customizedFetch(
    `${appConstants.IQ_HUB_API_URL}/userInfo`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...(accessToken && { [appConstants.IQ_HUB_TOKEN_NAME]: accessToken }),
      },
      credentials: "include",
    }
  );

  if (response.status !== 200) {
    window.dispatchEvent(new CustomEvent("IQ_LOGIN_REQUIRED"));
    return;
  }

  const { orgUserInfo } = await response.json();

  return orgUserInfo;
};
